import { createContext } from 'react';

// TODO: Change props to user info
export const ContextNotifications = createContext({});